import { fetchUtilisateur } from '@mairistem/finances-utils';
import type { SemanticCOLORS } from 'semantic-ui-react';

export const LOGIN_NON_RENSEIGNE = 'Login non renseigné';

// prenom/nom absents : l'utilisateur n'existe plus
export const formaterNomUtilisateur = (
	prenom?: string | null,
	nom?: string | null,
) => `${prenom ?? ''} ${nom ?? ''}`.trim() || LOGIN_NON_RENSEIGNE;

// Cache partagé entre tous les appelants pour eviter de refaire un appel
// pour un utilisateur deja recupere
const nomParIdentifiant = new Map<number, Promise<string>>();

export const getNomUtilisateur = (
	identifiantLogin?: number,
): Promise<string> => {
	if (!identifiantLogin) return Promise.resolve(LOGIN_NON_RENSEIGNE);

	if (!nomParIdentifiant.has(identifiantLogin)) {
		nomParIdentifiant.set(
			identifiantLogin,
			fetchUtilisateur(identifiantLogin)
				.then((utilisateur) =>
					formaterNomUtilisateur(utilisateur?.prenom, utilisateur?.nom),
				)
				.catch(() => LOGIN_NON_RENSEIGNE),
		);
	}

	return nomParIdentifiant.get(identifiantLogin);
};

// Alimente le cache avec un nom deja connu (ex: renvoye par l'API avec les
// montants), pour eviter un appel a fetchUtilisateur pour cet utilisateur
export const renseignerNomUtilisateur = (
	identifiantLogin: number | undefined,
	prenom: string | null,
	nom: string | null,
) => {
	if (!identifiantLogin || nomParIdentifiant.has(identifiantLogin)) return;

	nomParIdentifiant.set(
		identifiantLogin,
		Promise.resolve(formaterNomUtilisateur(prenom, nom)),
	);
};

export const COULEURS_INITIALES: SemanticCOLORS[] = [
	'red',
	'orange',
	'yellow',
	'olive',
	'green',
	'teal',
	'blue',
	'violet',
	'purple',
	'pink',
	'brown',
	'grey',
];

export const getCouleurUtilisateur = (
	identifiantLogin?: number,
): SemanticCOLORS => {
	if (!identifiantLogin) return 'grey';

	return COULEURS_INITIALES[identifiantLogin % COULEURS_INITIALES.length];
};

export const getInitiales = (nomUtilisateur: string) =>
	nomUtilisateur
		.split(' ')
		.filter(Boolean)
		.map((mot) => mot[0])
		.join('')
		.slice(0, 2)
		.toUpperCase();
